import { format } from 'date-fns'
import itLocale from 'date-fns/locale/it'
import { getCarContextKey, getSessionIdFromCar } from 'lib/carContextKey'

const normalizeInsertMessagesOptions = (attributeOrOptions) => {
  if (typeof attributeOrOptions === 'string') {
    return {
      attribute: attributeOrOptions,
      fallbackSessionId: null,
      useContextKey: true,
    }
  }

  return {
    attribute: attributeOrOptions?.attribute || 'plate',
    fallbackSessionId: attributeOrOptions?.fallbackSessionId ?? null,
    useContextKey: attributeOrOptions?.useContextKey !== false,
  }
}

export const insertMessagesInItems = (
  messages = [],
  items = [],
  attributeOrOptions = 'plate'
) => {
  const { attribute, fallbackSessionId, useContextKey } =
    normalizeInsertMessagesOptions(attributeOrOptions)

  const itemsByContextKey = new Map()
  const itemsByAttribute = new Map()

  items.forEach((item) => {
    if (!item) {
      return
    }

    if (useContextKey) {
      const contextKey = getCarContextKey(item, fallbackSessionId)
      if (contextKey && !itemsByContextKey.has(contextKey)) {
        itemsByContextKey.set(contextKey, item)
      }
    }

    const attributeValue = item[attribute]
    if (
      attributeValue !== undefined &&
      attributeValue !== null &&
      !itemsByAttribute.has(attributeValue)
    ) {
      itemsByAttribute.set(attributeValue, item)
    }
  })

  messages.forEach((message) => {
    if (!message) {
      return
    }

    const hasSessionContext = !!(
      getSessionIdFromCar(message) ?? fallbackSessionId
    )

    let item = null

    if (useContextKey && hasSessionContext) {
      const contextKey = getCarContextKey(message, fallbackSessionId)
      item = contextKey ? itemsByContextKey.get(contextKey) : null
    }

    if (!item && (!useContextKey || !hasSessionContext)) {
      item = itemsByAttribute.get(message[attribute])
    }

    if (!item) {
      return
    }

    item.messages ? item.messages.push(message) : (item.messages = [message])
  })
}

export const mapMessagesForDownload = (messages, t, admin) => {
  return messages.reduce((previous, message) => {
    const partner = admin
      ? `, ${t('common.excel.partner')}: ${message.partnerId}`
      : ''
    return `${previous}${format(
      new Date(message.createdAt),
      t('common.date.format'),
      {
        locale: itLocale,
      }
    )}${partner}
${message.message}

`
  }, '')
}
